import {Route, Routes, Outlet, Navigate} from 'react-router-dom'
import { PageLink, PageTitle } from '../../../_metronic/layout/core'
import { UsersListWrapper } from '../../modules/kyc/business/list/BusinessKycList'
import { KycDataListWrapper } from '../../modules/kyc/business/list/KycDataList'
import { SettingsWrapper } from './Settings'
import { HelpWrapper } from './Help'

const administrationBreadcrumbs: Array<PageLink> = [
    {
        title: 'Admin',
        path: '/administration/settings',
        isSeparator: false,
        isActive: true,
    },
    {
        title: 'Admin',
        path: '/administration/help',
        isSeparator: true,
        isActive: false,
    },
]

const AdministrationPage = () => {
    return (
        <Routes>
            <Route element={<Outlet/>}>
                <Route
                    path='settings'
                    element={
                        <>
                            <PageTitle breadcrumbs={administrationBreadcrumbs}>Tenant Setup</PageTitle>
                            <SettingsWrapper/>
                        </>
                    }
                />
                <Route
                    path='help'
                    element={
                        <>
                            <PageTitle breadcrumbs={administrationBreadcrumbs}>Troubleshooting, guidance, and support</PageTitle>
                            <HelpWrapper/>
                        </>
                    }
                />
            </Route>
            <Route index element={<Navigate to='/administration/settings'/>}/>
        </Routes>
    )
}

export default AdministrationPage
